<template>
  <div>
    <div class="mt-3 titlePage">
      Cadastro das Descrição das Opções de Inscrição para Vagas Reservadas
    </div>
    <fccTable
      v-if="mostraTabela"
      class="mt-3"
      striped
      hover
      :fields="fieldsVagas"
      :orderby="sortBy"
      :items="lstVagas"
      :actions="actionsSolicitacoes"
      responsive
      :optionsButton="optionSolicitacoes"
      :porPage="itemPorPage"
      :titlePage="titlePage"
      :mostrarQuantidade="false"
      :titlePDF="titlePage"
    ></fccTable>
    <fcc-modal
      centered
      id-modal="cadastroDescricacaoModal"
      title-modal="Cadastro das descrição"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <form @submit.prevent="addCadastro" autocomplete="off">
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-2">
              <fccInput
                extraClasses="inputLabel text-center"
                type="number"
                v-model="campo.ordem"
                required
                >Ordem</fccInput
              >
            </div>
            <div class="col-sm-2">
              <fccInput
                extraClasses="inputLabel text-center"
                type="number"
                required
                v-model="campo.idcampo"
                >ID_Campo</fccInput
              >
            </div>
            <div class="col-sm-2">
              <fccInput
                extraClasses="inputLabel text-center"
                type="number"
                required
                v-model="campo.valor"
                >Valor</fccInput
              >
            </div>
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="campo.descricao"
                >Descrição</fccInput
              >
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton tipo="submit">{{ labelsSystem.salvar }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fcc-modal>
    <fccTable
      v-if="mostraTabela"
      class="mt-4"
      striped
      hover
      :fields="fieldsTecnico"
      :orderby="sortBy"
      :items="usuariosPadrao"
      responsive
      pagination
      :porPage="'5'"
      :titlePage="titlePage"
      :mostrarQuantidade="false"
      :titlePDF="titlePage"
    ></fccTable>
  </div>
</template>


<script>
import axios from 'axios'
import store from '@/store'
import { optionButton, fieldsFinalizar } from './lstOptionButton'
import { optionButtonDesfazer, fieldsDesfazer } from './lstOptionButtonDesfazer'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      titleModalSituacao: '',
      sortBy: 'id_situacao',
      permissao: null,
      itemPorPage: '1000',
      lstVagas: [],
      lstVagasReservados: [],
      usuariosPadrao: [],
      campo: {},
      optionButton,
      fieldsFinalizar,
      optionButtonDesfazer,
      fieldsDesfazer,
      fieldsVagas: [],
      mostraTabela: false,
      fieldsTecnico: [
        {
          key: 'tecnico',
          label: 'Técnico',
          sortable: true
        },
        { key: 'data', label: 'Data', sortable: true },
        { key: 'situacao', label: 'Situação', sortable: true }
      ],
      actionsSolicitacoes: [
        {
          button: true,
          funcaoButton: 'deleteCadastro',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      optionSolicitacoes: [],
      actions: [],
      optionsButton: []
    }
  },
  props: {
    controlePage: Object,
    baseUrlPublicacao: String
  },
  methods: {
    mudarStatusVagas(number) {
      var text = number == 1 ? ' Finalizar' : ' Desfazer'
      this.callConfirm('Deseja realmente ' + text + ' ?', '').then((result) => {
        if (result.value) {
          if (number == 1) {
            this.divideCadastro(number)
          } else {
            this.finalizarOuDesfazerVagasReservadasProjetos(number)
          }
        }
      })
    },
    desfazerVagas() {
      this.mudarStatusVagas(2)
    },
    finalizaVagas() {
      this.mudarStatusVagas(1)
    },
    addCadastro() {
      this.campo.valor = parseInt(this.campo.valor)
      this.campo.idcampo = parseInt(this.campo.idcampo)
      this.lstVagas.push(this.campo)
      this.$root.$emit('bv::hide::modal', 'cadastroDescricacaoModal')
    },

    usarMedida(arr) {
      return arr.map((entry) => {
        return Object.keys(entry).reduce((obj, key) => {
          const value = entry[key]
          if (key === 'idcontrole') key = 'idcontrolepadrao'
          obj[key] = value
          return obj
        }, {})
      })
    },
    finalizarOuDesfazerVagasReservadasProjetos(number) {
      const spiDesfazer = {
        spi: this.controlePage.spi,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        tpSituacao: number
      }
      axios
        .post(
          this.baseUrlPublicacao + 'Publicacao/FinalizarOuDesfazerVagasReservadasProjetos',
          spiDesfazer,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarCadastro()
        })
        .catch(() => {})
    },
    async divideCadastro(number) {
      var inclui = this.lstVagas.filter((element) => element.idcontrole == 0)
      var edita = this.lstVagas.filter((element) => element.idcontrole > 0)

      //inclui = inclui.map((u) => ({ ...u, idvagaprojeto: 0 }))
      await this.addVagasReservadas(inclui, number)
      await this.editVagasReservadas(edita, number)
      this.carregaTexto()
    },
    async addVagasReservadas(inclui, number) {
      if (inclui.length > 0) {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            this.baseUrlPublicacao +
              'Publicacao/InserirVagasReservadaProjeto?Spi=' +
              this.controlePage.spi +
              '&CdFuncionario=' +
              this.dadosUserSession.usuCdFuncionario +
              '&TpSituacao=' +
              number,
            inclui,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarCadastro()
          })
          .catch(() => {})
      }
    },
    async editVagasReservadas(edita, number) {
      if (edita.length > 0) {
        const desfazer = number == 2

        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .put(
            this.baseUrlPublicacao +
              'Publicacao/AlterarVagasReservadaProjeto?Spi=' +
              this.controlePage.spi +
              '&CdFuncionario=' +
              this.dadosUserSession.usuCdFuncionario +
              '&TpSituacao=' +
              number +
              '&desfazer=' +
              desfazer,
            edita,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarCadastro()
          })
          .catch(this.setErrorSystem)
      }
    },
    bloqueadoStatusInscricoes() {
      this.callAlert(
        'Bloqueado',
        'Para desbloquear é necessário clicar no botão desfazer',
        'error',
        'error'
      )
    },
    listarVagasReservadasProjeto() {
      this.callConfirm('Deseja realmente carregar as mensagens padrão ?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .get(
              this.baseUrlPublicacao + 'Publicacao/ListarVagasReservadasPadrao',
              this.dadosLoginSession.fccTokenHeaders
            )
            .then((response) => {
              this.lstVagasReservados = response.data
              this.deparaVagasReservadas()
              this.carregaTexto()
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    lstPadraoUsuarios() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            'Publicacao/UsuariosCadastroReservas?spi=' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.usuariosPadrao = response.data
          this.mostraTabela = true
          setTimeout(() => {
            this.optionSolicitacoes = this.optionButton
            this.fieldsVagas = this.fieldsFinalizar
            this.actionsSolicitacoes = [
              {
                button: true,
                funcaoButton: 'deleteCadastro',
                icon: 'trash',
                tooltip: 'Excluir',
                objpermCodigo: store.state.permissaoMenu.excluir
              }
            ]
            if (response.data.length > 0) {
              const manipula =
                this.usuariosPadrao[response.data.length - 1].situacao.includes(
                  'CADASTRO FINALIZADO'
                )
              this.$emit('visualizaFinalizar', manipula)

              if (manipula) {
                this.optionSolicitacoes = this.optionButtonDesfazer
                this.fieldsVagas = this.fieldsDesfazer
                this.actionsSolicitacoes = [
                  {
                    button: true,
                    funcaoButton: 'bloqueadoStatusInscricoes',
                    icon: 'lock',
                    tooltip: 'Editar',
                    objpermCodigo: store.state.permissaoMenu.editar
                  }
                ]
              }
              if (this.permissao == null) {
                this.actionsSolicitacoes = [
                  {
                    button: true,
                    funcaoButton: 'bloqueadoStatusInscricoes',
                    icon: 'lock',
                    tooltip: 'Editar',
                    objpermCodigo: store.state.permissaoMenu.editar
                  }
                ]
                this.optionSolicitacoes = []
              }
            }
            this.carregaTexto()
          }, 1000)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    deparaVagasReservadas() {
      this.lstVagas.forEach((element) => {
        const verificaValor = this.lstVagasReservados.find(
          (mensagem) => mensagem.valor == element.valor && mensagem.idcampo === element.idcampo
        )
        if (verificaValor != null) {
          element.descricao = verificaValor.descricao
          element.ordem = verificaValor.ordem
        }
      })
    },
    addField() {
      this.campo = {}
      this.campo.idvagaprojeto = 0
      this.$root.$emit('bv::show::modal', 'cadastroDescricacaoModal')
    },
    deleteCadastro(_, item) {
      this.callConfirm('Deseja realmente excluir', item.descricao).then((result) => {
        if (result.value) {
          if (item.idvagaprojeto == 0) {
            this.lstVagas = this.arrayRemove(this.lstVagas, item)
          } else {
            this.deletandoCadastro(item)
          }
        }
      })
    },
    deletandoCadastro(item) {
      this.carregaTexto(this.codeMensagem('C02'))
      axios
        .delete(
          this.baseUrlPublicacao +
            'Publicacao/ExcluirVagasReservadasProjetos?Spi=' +
            this.controlePage.spi +
            '&CdFuncionario=' +
            this.dadosUserSession.usuCdFuncionario +
            '&TpSituacao=' +
            item.situacao,
          { data: [item.idvagaprojeto] },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarCadastro()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listarCadastro() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            'Publicacao/ListarVagasReservadasProjeto/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstVagas = response.data
          this.lstPadraoUsuarios()
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted() {
    this.listarCadastro()
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
  }
}
</script>
